<template>
    <main class="skiplink-target main" id="content" tabindex="-1">
        <div class="container">
            <header class="row">
                <div class="col-xl-8 col-xl-offset-2 col-lg-10 col-lg-offset-1">
                    <div class="content content--header">
                        <section class="content-header">
                            <h1>{{labels.bevestigingsScherm.kop}}</h1>
                        </section>
                    </div>
                </div>
            </header>
        <article>
            <div class="row">
                <div class="col-xl-8 col-xl-offset-2 col-lg-10 col-lg-offset-1">
                    <div class="content-background">
                        <div class="content">
                            <div class="notification notification--success">
                                <div class="notification__content">
                                    <h2 class="notification__title">{{labels.bevestigingsScherm.notificationTitle}}</h2>
                                    <span>{{labels.bevestigingsScherm.notificatieTekst}}</span>
                                    <br />
                                       <a :href="labels.bevestigingsScherm.notificatieUrl" class="">{{labels.bevestigingsScherm.notificatieButtonTekst}}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </article>
        </div>
    </main>
</template>

<script>
    import {mapGetters} from 'vuex';

    export default {
        name: "bevestigen",
        computed: {
            ...mapGetters(['labels'])
        },
        created() {
            this.$trackPageView('Gegevens invoeren');              
        },
    }
</script>

<style scoped>

</style>